import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlHelperService } from '@core/services/url-helper.service';
import { RedeploymentOrderSearchResult } from '@shared/interfaces/gridrows/redeployment-order-search-result.interface';
import { BooleanResult } from '@core/interfaces/boolean-result.interface';
import { FormGroup } from '@angular/forms';
import { BenchTemplateSearchResult } from '../../../shared/interfaces/gridrows/bench-template.interface';
import { OverlayService } from '../../../shared/services/overlay.service';

@Injectable()
export class BundleService {
  overlayService: OverlayService;
  constructor(private http: HttpClient,
              private urlHelper: UrlHelperService) {
    this.overlayService = inject(OverlayService);
  }

  addBundleToCart(id: number): Observable<BooleanResult> {
    this.overlayService.open();
    var url = this.urlHelper.getApiUrl() + "Bundle/AddBundleToCart/?id=" + id;
    return this.http.post<BooleanResult>(url, id);
  }
}
